import { render } from "./SwapBalanceSummary.vue?vue&type=template&id=e1b52d48&scoped=true"
import script from "./SwapBalanceSummary.vue?vue&type=script&lang=js"
export * from "./SwapBalanceSummary.vue?vue&type=script&lang=js"

import "./SwapBalanceSummary.vue?vue&type=style&index=0&id=e1b52d48&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1b52d48"]])

export default __exports__